import { render, staticRenderFns } from "./BdRate.vue?vue&type=template&id=746b9f90&"
import script from "./BdRate.vue?vue&type=script&lang=js&"
export * from "./BdRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports